import React from 'react'
import PropTypes from 'prop-types'
import { useToast } from '@chakra-ui/react'
import { Checkbox } from 'components/Toolkit'
import { Spinner } from 'reactstrap'
import { updateAdminCapabilities } from 'lib/admin-capabilities'

type Props = {
  value: boolean
  adminId: string
  capId: string
  onChanged?: () => void
}

const CapabilityToggle: React.FC<React.PropsWithChildren<Props>> = ({
  value,
  adminId,
  capId,
  onChanged
}) => {
  const [checked, setChecked] = React.useState(value)
  const [fetching, setFetching] = React.useState(false)
  const toast = useToast()

  React.useEffect(() => setChecked(value), [value])

  const handleChange = async () => {
    const nextValue = !checked
    setChecked(nextValue)
    setFetching(true)

    try {
      const assignment = { admin_id: adminId, capability_id: capId }
      await updateAdminCapabilities(
        nextValue ? { assignments: [assignment] } : { removals: [assignment] }
      )
      onChanged?.()
    } catch (error: any) {
      setChecked(!nextValue)
      toast({
        title: 'Unable to update capability',
        description: error?.message ?? String(error),
        status: 'error',
        duration: 5000
      })
    } finally {
      setFetching(false)
    }
  }

  return fetching ? (
    <Spinner />
  ) : (
    <Checkbox
      label={null}
      style={{ margin: 0 }}
      value={checked}
      disabled={fetching}
      onChange={() => void handleChange()}
    />
  )
}

CapabilityToggle.propTypes = {
  adminId: PropTypes.string.isRequired,
  capId: PropTypes.string.isRequired,
  onChanged: PropTypes.func,
  value: PropTypes.bool.isRequired
}

export default CapabilityToggle
